export { BasicHttpAuthenticationProvider } from './basicHttpAuthenticationProvider';